var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: _vm.isIcon && `add-task-wrapper` },
    [
      _vm._t(
        "default",
        function () {
          return [
            _vm.isIcon
              ? _c(
                  "button",
                  {
                    on: {
                      click: _vm.showModal,
                      mouseover: function ($event) {
                        _vm.isHovered = true
                      },
                      mouseout: function ($event) {
                        _vm.isHovered = false
                      },
                    },
                  },
                  [
                    !_vm.isHovered
                      ? _c("TagIcon", { staticClass: "w-4 h-4" })
                      : _vm._e(),
                    _vm.isHovered
                      ? _c("EditIconHover", { staticClass: "w-4 h-4" })
                      : _vm._e(),
                  ],
                  1
                )
              : [
                  _c("UiButton", {
                    attrs: {
                      buttonText: "Edit",
                      variant: "outline-black",
                      size: _vm.size,
                    },
                    on: { click: _vm.showModal },
                  }),
                ],
          ]
        },
        { showModal: _vm.showModal }
      ),
      _vm.modalShown
        ? _c("ActivityFormModal", {
            attrs: {
              modalId: "modal-lv2",
              project: _vm.project,
              projectId: _vm.projectId,
              projectActivity: _vm.projectActivity,
              currentUserRole: _vm.currentUserRole,
              currentUserId: _vm.currentUserId,
              companyId: _vm.companyId,
            },
            on: {
              activityAdded: _vm.onActivityAdded,
              activityUpdated: _vm.hideModal,
              close: _vm.hideModal,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }